import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom"
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button
} from "reactstrap";
import { Navigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import API, { base } from "api.js";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";

const Test = () => {
  const [data, setData] = useState(false);
  const params = useParams();

  useEffect(() => {
    API({
        method: 'GET',
        url: 'template/' + params.id
      }).then(data => {
        setData(data.data.data);
    }).catch(()=>{      
    });
  }, [params.id]);

  const fileURL = () => {
    return `${base}${data.pdf}#toolbar=0`;
  }
  
  return (
    <>      
      {data &&
        <div className="content p-0 w-100">
          <DashboardHeader title={data && data.title} />
          
          <Row className="outer-wrapper">
            <Col xs={12} className="p-0">
              <Card className="border-0">
                <CardBody>
                  <Row className='unselectable'>
                    <Col>
                      {data && 
                        <embed
                          width="100%"
                          height="750px"
                          src={fileURL(data.pdf)}
                        />
                      }
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      }
    </>
  );
};

export default Test;